import React from 'react';

import PropTypes from 'prop-types';

import { MDash } from 'ui-components/components/mdash';
import { Text, TextType } from 'ui-components/components/text';

import style from './service-details.module.less';

const ServiceDetailsField = ({ labelId, label, value }) => {
  return (
    <div className={style['service-details-field']}>
      <Text id={labelId} textType={TextType.Label} value={label} />
      <Text aria-describedby={labelId} textType={TextType.Caption} value={value || <MDash />} />
    </div>
  );
};

export default ServiceDetailsField;

ServiceDetailsField.propTypes = {
  labelId: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.node,
};
